import { Player } from '../types';

export const generateId = (prefix = '') => prefix + Date.now().toString(36) + Math.random().toString(36).substr(2, 9);

export const generateSlug = (name: string): string => {
    if (!name) return '';
    return name
        .toLowerCase()
        .normalize('NFD') // Decompose diacritics
        .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
        .replace(/[^a-z0-9]+/g, '-') // Replace non-alphanumeric with dashes
        .replace(/(^-|-$)/g, ''); // Remove leading or trailing dashes
};
export const isEmoji = (str: string) => {
    if (!str) return false;
    const ranges = [
        '\u00A9', '\u00AE', '[\u2000-\u3300]', '\uD83C[\uD000-\uDFFF]', '\uD83D[\uD000-\uDFFF]', '\uD83E[\uD000-\uDFFF]'
    ];
    return new RegExp(ranges.join('|'), 'g').test(str);
};

export const getAvatarHTMLString = (player?: Player) => {
    const defaultInitials = player && player.name ? player.name.charAt(0).toUpperCase() : '?';
    if (player && player.avatar && (player.avatar.startsWith('http') || player.avatar.startsWith('data:image'))) {
        return `<img src="${player.avatar}" alt="${player.name || 'Avatar'}" class="w-full h-full object-cover">`;
    }
    return `<div class="avatar-emoji">${(player && player.avatar) || defaultInitials}</div>`;
};

export const generateGroupCode = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let result = '#';
    for (let i = 0; i < 6; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
};

export const generateTournamentCode = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let result = '#T';
    for (let i = 0; i < 7; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
};

export const getDynamicTeamName = (
    playerIds: (string | undefined)[],
    allPlayers: Player[],
    fallbackName: string = 'Équipe'
): string => {
    // Filter out undefined/null ids
    const validIds = playerIds.filter(Boolean) as string[];

    if (validIds.length === 0) return fallbackName;

    const names = validIds.map(id => {
        const p = allPlayers.find(player => player.id === id);
        return p?.pseudo || p?.name || 'Joueur';
    });

    return names.join(' & ');
};
